"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyAddressSchema = exports.AUSTRALIAN_STATES = void 0;
const yup = __importStar(require("yup"));
const MyStakeAddress_1 = require("./MyStakeAddress");
const OptionGrant_1 = require("./OptionGrant");
const UpdateAddress_1 = require("./UpdateAddress");
exports.AUSTRALIAN_STATES = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];
const isStreetAddress = (value) => !value || !UpdateAddress_1.RESTRICTED_STREET_ADDRESS_TOKENS.some((token) => value.toLowerCase().includes(token.toLowerCase()));
/** Company address in any country, using the IAddress field names. Matches the API's company address rules. */
exports.CompanyAddressSchema = yup.object().shape({
    ...MyStakeAddress_1.MyStakeAddressSchema,
    street: MyStakeAddress_1.MyStakeAddressSchema.street.test("street", "Must be a street address", isStreetAddress),
    state: yup
        .string()
        .trim()
        .when("country", ([country], schema) => (0, MyStakeAddress_1.isAustralianCountry)(country)
        ? schema.required(MyStakeAddress_1.STATE_REQUIRED).oneOf(exports.AUSTRALIAN_STATES, "Please enter an Australian state")
        : schema.max(100))
        .label("State"),
    postcode: yup
        .string()
        .trim()
        .when("country", ([country], schema) => (0, MyStakeAddress_1.isAustralianCountry)(country)
        ? schema.required(MyStakeAddress_1.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE).matches(/^\d{4}$/, MyStakeAddress_1.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE)
        : schema.max(10, "Postcode must be at most 10 characters"))
        .label("Postcode"),
    authorisingOfficer: OptionGrant_1.AuthorisingOfficerSchema,
});
//# sourceMappingURL=CompanyAddress.js.map